"use client";
import "./GalleriesSlider.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useRef, useState } from "react";
import { A11y, Navigation } from "swiper/modules";
import GalleriesSlideCard from "../GalleriesSlideCard/GalleriesSlideCard";
import { useThemeContext } from "@/context/ThemeContext";
import { GalleryGetResponse } from "@/interfaces/galleries/galleries-response";
import { SubTypesSelect } from "../Admin/CardPhoto/SubTypesSelect";
import { SubTypesEnums } from "@/constants/enums";
import { PhotoSubtype } from "@/interfaces/galleries/Galleries";

interface GallerySliderPropsI {
  title: string;
  loading: boolean;
  gallery: GalleryGetResponse[];
  subtypeFilter?: boolean;
}

function GalleriesSlider(props: GallerySliderPropsI) {
  const { loading, gallery, subtypeFilter, title } = props;
  const prevButton = useRef<any>(null);
  const nextButton = useRef<any>(null);
  const [galleries, setGalleries] = useState<GalleryGetResponse[]>([]);
  const [swiper, setSwiper] = useState<any>(null);
  const { theme } = useThemeContext();
  const [subtype, setSubtype] = useState<PhotoSubtype>(SubTypesEnums.regular);
  const handleSubType = (value: PhotoSubtype | "all") => {
    if ("all" === value) return;
    if (value === "cool/rare") {
      const filter = gallery.filter(
        (item) => item.photosCoolRare && item.photosCoolRare > 0
      );
      setGalleries(filter);
    }
    if (value === "exclusive") {
      const filter = gallery.filter(
        (item) => item.photosExclusive && item.photosExclusive > 0
      );
      setGalleries(filter);
    }
    if (value === "regular") {
      setGalleries(gallery);
    }
    setSubtype(value);
  };
  useEffect(() => {
    if (swiper) {
      swiper.update();
    }
    setGalleries(gallery);
  }, [loading]);

  return (
<div className={`galleries-slider-component-main-container ${theme}`}>
  <div className="title-container relative">
  <div className="flex flex-wrap items-center justify-between gap-4 xl:block">
    <h2 className="title">{title}</h2>
    {subtypeFilter && (
      <div className="xl:absolute xl:bottom-[-70px] xl:left-6">
        <SubTypesSelect
          selected={subtype}
          onClick={handleSubType}
        />
      </div>
    )}
  </div>
</div>
      <div className={`swiper-container `}>
        <Swiper
          modules={[Navigation, A11y]}
          spaceBetween={10}
          slidesPerView={3}
          loop={true}
          navigation={{
            prevEl: prevButton.current,
            nextEl: nextButton.current,
          }}
          breakpoints={{
            901: {
              slidesPerView: 4,
            },
            1100: {
              slidesPerView: 5,
            },
          }}
          scrollbar={{ draggable: true }}
          onSwiper={(swiper) => {
            setSwiper(swiper);
          }}
          onSlideChange={() => {}}
        >
          {galleries.map((gallery, i) => {
            return (
              <SwiperSlide key={"swiper-" + (gallery ? gallery._id : i)}>
                <GalleriesSlideCard gallery={gallery} loading={loading} />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div
          className="custom-swiper-button-prev"
          ref={prevButton}
          onClick={() => prevButton.current?.click()}
        ></div>
        <div
          className="custom-swiper-button-next"
          ref={nextButton}
          onClick={() => nextButton.current?.click()}
        ></div>
      </div>
    </div>
  );
}

export default GalleriesSlider;
